import { render, staticRenderFns } from "./FileUploadButtonProductImage.vue?vue&type=template&id=edaa43e8&scoped=true&"
import script from "./FileUploadButtonProductImage.vue?vue&type=script&lang=js&"
export * from "./FileUploadButtonProductImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaa43e8",
  null
  
)

export default component.exports